<template>
  <Row>
    <Col span="18">
      <Select
        v-model="searchParams.categoryCode"
        placeholder="请选择类目"
        class="public-inp"
      >
        <Option
          v-for="item in productCategoryAll"
          :value="item.code"
          :key="item.code"
          >{{ item.name }}</Option
        >
      </Select>
      <Select
        v-model="searchParams.status"
        placeholder="请选择状态"
        class="public-inp"
      >
        <!-- 状态，01：已发布；02：已上架；03：已下架；04：停用 -->
        <Option value="">全部</Option>
        <!-- <Option value="01">启用</Option> -->
        <Option value="02">已上架</Option>
        <Option value="03">已下架</Option>
        <!-- <Option value="04">禁用</Option> -->
      </Select>
      <Select
        v-model="searchParams.brandCode"
        placeholder="请选择品牌"
        class="public-inp"
      >
        <Option v-for="item in brandAll" :value="item.code" :key="item.code">{{
          item.name
        }}</Option>
      </Select>
      <Input
        v-model="searchParams.name"
        placeholder="请输入商品名称"
        class="public-inp"
      />
      <Input
        v-model="searchParams.spuName"
        placeholder="请输入SPU名称"
        class="public-inp"
      />
      <Button
        type="primary"
        icon="md-search"
        @click="getList()"
        v-access="'skuInfo.query'"
        >搜索</Button
      >
      <Button @click="resetList()" v-access="'skuInfo.reset'">重置</Button>
    </Col>
    <Col span="6">
      <Button
        type="primary"
        icon="md-add"
        class="public-fr"
        @click="addFn()"
        v-access="'skuInfo.add'"
        >添加SKU模板</Button
      >
    </Col>
    <Col span="24">
      <Table
        :style="{ marginTop: '10px' }"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="productSkList.data || []"
      >
        <template slot-scope="{ index }" slot="sort">
          {{ index + 1 }}
        </template>
        <template slot-scope="{ row }" slot="labelNameList">
          <Tag v-for="label in row.labelNameList" :key="label.labelCode">{{
            label.labelName
          }}</Tag>
        </template>
        <template slot-scope="{ row, index }" slot="name">
          <a href="javascript:;" @click="detailFn(row, index)">{{
            row.name
          }}</a>
        </template>
        <template slot-scope="{ row }" slot="prdType">
          <p>{{ row.prdType | showPrdType }}</p>
        </template>
        <template slot-scope="{ row }" slot="prdSource">
          <p>{{ row.prdSource | showPrdSource }}</p>
        </template>
        <template slot-scope="{ row }" slot="supplyMode">
          <p>{{ row.supplyMode | showSupplyMode }}</p>
        </template>

        <template slot-scope="{ row }" slot="status">
          <i-switch
            v-access="'skuInfo.status'"
            :disabled="row.status != '02' && row.status != '03'"
            :value="row.status == '02'"
            :before-change="beforeStateChange"
            @on-change="stateChange(row, $event)"
          />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="editFn(row, index)" v-access="'skuInfo.edit'"> 编辑</a>
          <a @click="removeFn(row, index)" v-access="'skuInfo.delete'">删除</a>
          <a @click="detailFn(row, index)" v-access="'skuInfo.details'">详情</a>
        </template>
      </Table>
      <Page
        :style="{ float: 'right', marginTop: '10px' }"
        :total="productSkList.total"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        show-elevator
        @on-change="pageNumChange"
        @on-page-size-change="pageSizeChange"
      />
    </Col>
  </Row>
</template>
<script>
import { mapGetters } from "vuex";
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "商品名称",
    slot: "name",
  },
  {
    title: "商品编码",
    key: "prdCode",
  },
  {
    title: "商品类型",
    slot: "prdType",
  },
  {
    title: "商品货源",
    slot: "prdSource",
  },
  {
    title: "供货方式",
    slot: "supplyMode",
  },
  {
    title: "资金商ErpCode",
    key: "spErpCode",
    width: 100,
  },
  {
    title: "SPU名称",
    key: "spuName",
  },
  {
    title: "建议零售价(元)",
    key: "recommendPrice",
  },
  {
    title: "品牌名称",
    key: "brandName",
  },
  {
    title: "所属分类",
    key: "categoryName",
  },
  {
    title: "属性",
    key: "propertyValueName",
  },
  {
    title: "标签",
    slot: "labelNameList",
  },
  {
    title: "状态",
    slot: "status",
    width: 100,
  },
  {
    title: "操作",
    slot: "action",
    width: 120,
  },
];

const searchParams = {
  categoryCode: "",
  status: "",
  brandCode: "",
  spuName: "",
  name: "",
  page: 1,
  pageSize: 10,
};
export default {
  data() {
    return {
      loading: false,
      columns,
      tbList: [],
      total: 0,

      searchParams: JSON.parse(JSON.stringify(searchParams)),
    };
  },
  computed: {
    ...mapGetters("skuInfo", {
      productSkList: "getProductSkList",
    }),
    ...mapGetters("category", {
      productCategoryAll: "getProductCategoryAll",
    }),
    ...mapGetters("brand", {
      brandAll: "getBrandAll",
    }),
  },
  filters: {
    showPrdType(prdType) {
      let sTxt = "";
      switch (prdType) {
        case "normal":
          sTxt = "一般贸易";
          break;
        case "tax":
          sTxt = "保税贸易";
          break;
        default:
          break;
      }

      return sTxt;
    },
    showPrdSource(prdSource) {
      let sTxt = "";
      switch (prdSource) {
        case "platform":
          sTxt = "平台供货";
          break;
        case "shop":
          sTxt = "门店自采";
          break;
        default:
          break;
      }

      return sTxt;
    },
    showSupplyMode(supplyMode) {
      let sTxt = "";
      switch (supplyMode) {
        case "shop":
          sTxt = "直供门店";
          break;
        case "customer":
          sTxt = "直供用户";
          break;
        default:
          break;
      }

      return sTxt;
    },
  },
  created() {
    // 获取初始列表数据
    this.getList();
    // 获取类目数据
    this.$store.dispatch("category/getProductCategoryAll");
    // 获取品牌数据
    this.$store.dispatch("brand/getBrandAll");
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("skuInfo/getProductSkList", this.searchParams)
        .then((res) => {})
        .finally(() => {
          this.loading = false;
        });
      // this.$api.skuSearch(this.searchParams).then((res) => {
      //   this.loading = false;
      //   if (res.code == "200") {
      //     this.tbList = res.data;
      //     this.total = res.total;
      //   }
      // });
    },
    // 页码
    pageNumChange(d) {
      this.searchParams.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.searchParams.pageSize = d;
      // 页码变动触发pageNumChange
      if (this.searchParams.page == 1) {
        this.getList();
      } else {
        this.searchParams.page = 1;
      }
    },
    // 重置
    resetList() {
      this.searchParams = JSON.parse(JSON.stringify(searchParams));
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 详情
    detailFn(d, i) {
      if (!d.code) return;

      this.$router.push({
        path: "detail",
        query: {
          code: d.code,
        },
      });
    },
    // 打开新增
    addFn() {
      this.$router.push({
        path: "add",
      });
    },
    // 打开编辑
    editFn(d, i) {
      if (!d.code) return;
      this.$router.push({
        path: "add",
        query: {
          code: d.code || "",
        },
      });
    },
    // 删除部门
    removeFn(d, i) {
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api.skuDelete({ code: d.code }).then((res) => {
            if (res.code == "200") {
              this.$Message.success("删除成功");
              this.getList();
            }
          });
        },
      });
    },
    beforeStateChange() {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: "切换确认",
          content: "您确认要切换状态吗？",
          onOk: resolve,
          oncancel: reject,
        });
      });
    },
    /**
     * 状态
     * v true 上架； false 下架
     * */
    stateChange(d, v) {
      this.$store
        .dispatch(
          v ? "skuInfo/productSkuEnable" : "skuInfo/productSkuDisabled",
          {
            code: d.code,
          }
        )
        .then((res) => {
          if (res.code == "200") {
            this.$Message.success(v ? "启用成功" : "禁用成功");
            this.getList();
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/skuInfo/list.vue